import { apiProxyRequest } from "Api/apiProxyRequest";
import type { Activity } from "Api/activity/types";

export const getActivityBySelfUrlRequest = (
  activity: Activity,
  params: { timeout: number }
) => apiProxyRequest<Activity>(activity._links?.self!.href!, "GET", params);
